module.exports = __webpack_public_path__ + "static/img/Brand_2.2156c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/Brand_2.jpg
// module id = j+HM
// module chunks = 1